import React, { Fragment } from 'react';
import { Link, HashRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { setBookingRef, setCheckinRoomNo, getAllergyOptions, getCountryOptions, getCardChecksData, cardValidation, setSelfieVideo, setIdCardImage, setIdCardImageBack, setCheckinCurrentPageName, setSelectedIdType, setCheckinWidgetLaunchTime, GetDynamicBookingForm, setAbortCheckinProcess } from '../../action/autoCheckin';
import axios from 'axios';
import { CMSPath, defultIP, DEMO, CARD_VALIDATION_ENABLED, CLICKED, SHOW_ALLERGY_OPTIONS, ENABLE_US_DATE_FORMAT, PHONE_MANDATORY, EMAIL_MANDATORY, IDCARD_DEMO } from '../../../config/constant';
import {
  setRegPage, setLoadingMass,
  validateGuestdetail, popupOpenClose,
  setDeviceLoginPage, currentWidget, setCheckInAddress,
  setShowCustomPopup
} from '../../../action/action'
import { fetchSessionToken } from '../../../JS/fetchSessionToken'
import clientConfigApi from '../../../config/config';
import { data } from 'jquery';
import moment from 'moment';
import { mobileCheckinColorConfig } from '../../JS/colorConfig'
import AddCard from './lightbox.jsx';
import StripeCardFlow from './addCardStripe.jsx'
import APIFailScreen from './apiFailScreen';
import {withTranslation} from 'react-i18next'
import SuccessFailScreen from '../../UI/SuccessFailScreen';
import Loader from '../../UI/loader';
import { setGoHome } from '../../action/homeAction';
import { getDefaultAnalyticsLabel, toBool } from '../../JS/utility';
import { getGuestDocListData, sendAnalytics } from '../../../action/homeAction';
import IdCardCapture from './index'
import SelfieCapture from './VerifyIdentity'
import VerifyConfidance from './ConfidenceShow'
import CheckinStepsGuide from './checkinStepsGuide';
import LoggedInErrorScreen from './apiFailScreen'
import Lightbox from './lightbox';
import GdprPolicy from './gdprPolicy';
import { dateFormatHandler } from "../../../JS/dateFormatHandler"
import { scrollToTop } from '../../../JS/scrollToTop';
import ClearVerification from './clearVerification';
import Shift4 from './shift4';
import BookingForm from './bookingForm';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import Shift4_V2 from './Shift4_V2.jsx';
import ScanIdandSelfieTogether from './ScanIdandSelfieTogether/index.jsx';
import FreedomPay from './freedomPay1.jsx';

class Booking extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
        todayDate: null,
        inputDateFormat: null,
        selectedDate: null,
        selectedComp: null,
        sessionToken: localStorage.getItem('GuestJourneySessionToken'),
        roomNo: '',
        inProgress: false,
        showCardVerified: false,
        showLoader: false,
        roomLinkSuccess: false,
        roomLinkFailed: false,
        selectAllergy: 'None',
        email:'',
        countryPhoneCode:null,
        phone:null,
        firstName: "",
        lastName:'',
        eta: "",
        extraData: null,
        bookingNumber:'',
        showBookingField: false,
        guest_book_error: false,
        guest_book_error_msg: null,
        guest_book_loading:false,
        checkinGuest_loading:false,
        checkinGuest_error:false,
        checkinGuest_error_msg:null,
        checkinGuest_success:false,
        cardVerified: false,
        firstLaunch: true,
        showErrorScreen: false,
        address:{
          "addressLine1": "",
          "addressLine2": "",
          "city": "",
          "state": "",
          "postalCode": "",
          "country": ""
        },
        confirmationNumber:null,
        otherAllergies: "",
        goBack:false,
        showFailScreen:false,
        apiFailErrorMsg:null,
        setupIntentSecret: "",
        exitCheckinFlow: false,
        showIdCardCapture: false,
        showSelfieCapture: false,
        showVerifyConfidance: false,
        showGDPR: false,
        dynamicFormIndex: 0,
        showAccompanyGuestFlow: false,
        DynamicBookingFormRequestData: [],
        renderDateInput: false,
        checkinSessionToken: localStorage.getItem("checkinSessionToken"),
        
    }
    this.getObject = this.getObject.bind(this);
    this.handleBookingRefNo = this.handleBookingRefNo.bind(this);
    this.doCheckin = this.doCheckin.bind(this);
    this.callBackFunc = this.callBackFunc.bind(this);
    this.guestBookingHandler = this.guestBookingHandler.bind(this);
    this.checkInGuestHandler = this.checkInGuestHandler.bind(this);
    this.addressHandler = this.addressHandler.bind(this);
    this.handlePreCheckInSelectedDate = this.handlePreCheckInSelectedDate.bind(this);
    this.checkInInfoHandler = this.checkInInfoHandler.bind(this);
    this.readFile = this.readFile.bind(this);
    this.guestBookFormData = new FormData();
    this.checkinRoomNum = null;
    this.maxRetry = this.props.cardChecksData.guestValidationMaxRetry ? this.props.cardChecksData.guestValidationMaxRetry : 3;
    this.addressFlagCount = 0;
    this.dateInputCss = `
    .rdp-day_selected {
        color: ${this.props.menuColor.assetFontSelectorColor};
        background-color: ${this.props.menuColor.assetBackgroundSelectorColor};
    }`;
    this.emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  }

  getObject(key) {

    if (!this.props.idCardResponse){
      return null;
    }

    if(key=='raw_text'){
      let rawText = this.props.idCardResponse.raw_text ? this.props.idCardResponse.raw_text.join(",") : "";

      if(rawText !== "None" && rawText !== "none" && rawText !== undefined){
        return rawText;
      }
    }

    if(key=='idType'){
      let rawText = this.props.idCardResponse.type.name;

      if(rawText !== "None" && rawText !== "none" && rawText !== undefined){
        return rawText;
      }
    }

    let obj = {}
    for (obj of this.props.idCardResponse.fields){
      if (obj.key == key){
        if(obj.value !== "None" && obj.value !== "none" && obj.value !== undefined){
          return obj.value;
        }
      }
    }
    return null;
  }


  clearGuestBookData = () => {
    this.guestBookFormData.delete('confirmationNumber');
    this.guestBookFormData.delete('lastName');
    this.guestBookFormData.delete("sessionToken");
    this.guestBookFormData.delete("actionKey");
  };


  addressHandler(event){
    const updtAdd = {...this.state.address,
      [event.target.name]: event.target.value};
  
    this.setState({address:updtAdd})
  }

  callBackFunc(status, room, locationId, errorMessage) {
    if(status){
      localStorage.setItem('room', room);
      this.props.setCheckinRoomNo(room);
      this.setState({inProgress: false, roomLinkFailed: false, roomLinkSuccess: true});

      let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
        this.props.sendAnalytics(
            null, // as no guesdetails in logout state 
            this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
            "CHECK-IN - SUCCESS", 
            {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": "BOOKING DETAILS", "widgetSessionId": this.state.checkinSessionToken}, 
            0, 
            false // guest is not logged in
        );

    }else{
      console.log("0" + this.maxRetry)
      if((this.maxRetry-1) <= 0){
        this.setState({checkinGuest_loading:false , showLoader:false ,showFailScreen:true, apiFailErrorMsg: "We could not find your records for check-in. Please verify your details and try again or contact the Front Desk",exitCheckinFlow: true, inProgress: false, roomLinkFailed: true, roomLinkSuccess: false});
      }else{
        this.maxRetry = this.maxRetry-1
        this.setState({checkinGuest_loading:false , showLoader:false ,showFailScreen:true, apiFailErrorMsg: errorMessage, inProgress: false, roomLinkFailed: true, roomLinkSuccess: false})
      }

      let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
        this.props.sendAnalytics(
            null, // as no guesdetails in logout state 
            this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
            "CHECK-IN - FAILED", 
            {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": "BOOKING DETAILS", "widgetSessionId": this.state.checkinSessionToken, "errorMessage": errorMessage || "Something went wrong"}, 
            0, 
            false // guest is not logged in
        );
    }
  }

  doCheckin(){
    this.setState({inProgress: true, roomLinkFailed: false, roomLinkSuccess: false});
    let lastName = this.state.lastName;
    let roomNumber = this.state.roomNo;
    console.log(`linking to room: ${roomNumber}`)
    let encodData = fetchSessionToken();
    this.props.validateGuestdetail(encodData, lastName, roomNumber, this.callBackFunc);
    // this.callBackFunc(true, roomNumber, null)
  }

 
  handleBookingRefNo(event){
    let value = event.target.value;
    this.setState({bookingNumber:value});
    this.props.setBookingRef(value);
    
    if (value && value.length > 7){
      let room_no = value.substring(4,7);
      // this.props.setCheckinRoomNo(room_no);
      this.setState({roomNo: room_no})
    }
    console.log(value);
    
  }

  handlePreCheckInSelectedDate = (selectedDate) => {

    if (!selectedDate) {
      this.setState({ selectedDate: this.state.todayDate, inputDateFormat: dateFormatHandler(new Date(this.state.todayDate).toISOString(), this.props.dateFormat)})
    } else {

        // converting to local date string
        const year = selectedDate.getFullYear();
        const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
        const day = String(selectedDate.getDate()).padStart(2, '0');

        const localDateString = `${year}-${month}-${day}`;
        this.setState({ selectedDate: localDateString, inputDateFormat: dateFormatHandler(new Date(localDateString).toISOString(), this.props.dateFormat)})
    }

    this.setState({ renderDateInput: false})
  }

  resOnError = (error) => {
    console.log('error: ', error);
      alert("resOnError - " + error.code);
  }

  readFile(uri, form_key,formData, callback){

    const self = this;
    function readBinaryFile(fileEntry) {
      fileEntry.file(function (file) {
          var reader = new FileReader();

          reader.onloadend = function() {
              var blob = new Blob([new Uint8Array(this.result)], { type: file.type });
              formData.append(form_key, blob, fileEntry.name);
              // console.log("file read: ", form_key);

          };

          reader.readAsArrayBuffer(file);

      }, self.resOnError);
    }

    const convertUrlToBinaryWeb = (dataURL) => {
      const arr = dataURL.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    }

    // console.log('reading file: ', form_key);
    if(window.cordova) {
      window.resolveLocalFileSystemURL(uri, readBinaryFile, self.resOnError)
    } else {
      const blob = convertUrlToBinaryWeb(uri);
      formData.append(form_key, blob, 'image.jpg');

      if (callback) {
        callback();
      }
    }
  }

  dateFormatHandler = (date) => {

    if(!date){
      return null;
    }

    let now = moment(date);
   
    if(!now.date()){
      now = moment(date,"DD-MM-YYYY");
    }

    return now ? now.format("YYYY-MM-DD") : null;
  }

 cardValidationCallback = (setupIntentSecret, error) => {
   if(setupIntentSecret){
    this.setState({setupIntentSecret: setupIntentSecret})
    this.setState({showLoader: false})
    this.setState({guest_book_error:false, selectedComp: "screen2"});
   } else {
    this.props.popupOpenClose(true, error && error.msg || "Something went wrong")
    this.setState({showBookingField: true, showLoader: false})
   }
  }

  checkIDLastName = () => {

    let rawData = this.getObject("raw_text").toLowerCase();

    if(!rawData.includes(this.state.lastName.trim().toLowerCase())){
      this.props.popupOpenClose(true, "Last name entered does not match with the last name on the ID");
      this.setState({selectedComp: null, showVerifyConfidance: false})
      this.props.setSelectedIdType(null);
      this.props.setIdCardImageBack(null)
      this.props.setIdCardImage(null)
      this.props.setSelfieVideo(null)
      scrollToTop()
      return;
    }

    this.setNextScreen();
  }

  setNextScreen = () => {

    if(this.props.cardChecksData.cardValidationEnabled){
      // this.props.cardValidation("register", response.data.payload.confirmationNumber, this.cardValidationCallback)
      this.setState({guest_book_error:false, selectedComp: "screen2", showVerifyConfidance: false});
    } else {
      this.setState({guest_book_error:false, selectedComp: "screen3", showVerifyConfidance: false}); // change to scree3 to enable card details capture
      scrollToTop();
    }
  }

  guestBookingHandler(){

    const { t } = this.props

    if(this.state.lastName){

      let cardVerified = (localStorage.getItem('cardVerfied') == "true")

      this.setState({guest_book_loading:true});
      this.guestBookFormData.append('confirmationNumber',this.state.bookingNumber);
      this.guestBookFormData.append('lastName',this.state.lastName);
      this.guestBookFormData.append("sessionToken",this.state.sessionToken);
      this.guestBookFormData.append("actionKey","bookingEnquiry");
      this.guestBookFormData.append("legNumber","");

      if(this.props.preCheckInEnabled && this.state.DynamicBookingFormRequestData[1]){
        this.setState({dynamicFormIndex: 1});
      } else {
        this.setState({dynamicFormIndex: 0});
      }

      this.setState({
            bookingNumber: t('check_in.demo_checkIn_matrix.bookingNo'), 
            roomNo: t('check_in.demo_checkIn_matrix.bookingNo').substring(4,7),
            showIdCardCapture: true,
            email: t('check_in.demo_checkIn_matrix.email'),
            phone: t('check_in.demo_checkIn_matrix.phone')
          });

          localStorage.setItem("checkinSessionBookingNumber", t('check_in.demo_checkIn_matrix.bookingNo'))

          const demo_checkIn_matrix_address = t('check_in.demo_checkIn_matrix.address', { returnObjects: true })
          this.props.setCheckInAddress({...demo_checkIn_matrix_address})

    }
  }

  checkInInfoHandler(extraData){
    console.log(extraData);
    this.setState({address: { ...this.state.address ,...extraData.address}, email: extraData.email, phone: extraData.phone, selectAllergy: extraData.allergies, otherAllergies: extraData.otherAllergies, extraData: extraData},
       () => this.checkInGuestHandler())
  }

  checkInGuestHandler(){

    this.setState({checkinGuest_loading:true , showLoader:true , loderMessage: "Please wait"});

    const idDetails = {
      "idType": this.getObject('idType'),
      "passportNumber": this.getObject("Id No."),
      "effectiveDate": this.dateFormatHandler(this.getObject("Date of Issue")),
      "expirationDate": this.dateFormatHandler(this.getObject("Date of Expiry")),
      "placeOfIssue": this.getObject("Place of Issue"),
      "countryOfIssue": this.getObject("Country Code"),
      "birthDate": this.dateFormatHandler(this.getObject("Date of Birth")),
      "nationality": this.getObject("Nationality")
    }



    console.log("id details",idDetails);
  let room = this.state.bookingNumber.substr(4,3)
  console.log("room", room)
  this.checkinRoomNum =  room;
  this.props.setCheckinRoomNo(room);
  this.setState({checkinGuest_error:false, checkinGuest_success:true});
  this.doCheckin();
  localStorage.setItem('VerifiedUser', true)
  }



  dayFormatHandler(date){
    return date.getDate() < 10 ? `0${date.getDate()}` :  date.getDate()
  }


  monthFormatHandler = (month) => {
    return month < 10 ? `0${month}` : month;
  }

  getStateList = (id,arr) => {

    let stateList = [];

    for (let obj of arr){
      if(id == obj.countryId){
        stateList = obj.stateList
      }
    }

    return stateList;
  }


  // getCountryCode = (name, arr) => {
  //   let code;
  //   for (let obj of arr){
  //     if(obj.countryName.toLowerCase().includes(name.toLowerCase)){
  //       code = obj.countryId
  //     }
  //   }

  //   return code;
  // }

  handleCLEARData = (data) => {
    console.log("Clear Id verification data reponse" + JSON.stringify(data))
    this.setState({firstName: data.member_data.given_name})
    this.setState({phone: data.member_data.phone})
    this.setState({email: data.member_data.email})
  }


  componentDidUpdate(prevPro, prevState){
    mobileCheckinColorConfig(this.props.menuColor);

    let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
    if(this.state.selectedComp == "screen3"){

      if(this.addressFlagCount < 1){
        this.setState({address: this.props.checkInAddress})
        this.addressFlagCount = this.addressFlagCount+1
      }
      if(prevState.selectedComp != this.state.selectedComp){
        this.props.setCheckinCurrentPageName("BOOKING DETAILS")
        const checkin_bdetails_event_sent = localStorage.getItem("checkin_bdetails_event_sent");
        if(!checkin_bdetails_event_sent){
          this.props.sendAnalytics(
              null, // as no guesdetails in logout state 
              this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
              "BOOKING DETAILS", 
              {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": "BOOKING DETAILS", "widgetSessionId": this.state.checkinSessionToken}, 
              0, 
              false // guest is not logged in
          );
        }
      }
    }

    if(this.state.selectedComp == "screen2"){
      if(prevState.selectedComp != this.state.selectedComp){
        this.props.setCheckinCurrentPageName("CREDIT CARD DETAILS")
        const checkin_ccdetails_event_sent = localStorage.getItem("checkin_ccdetails_event_sent");
    
        if(!checkin_ccdetails_event_sent){
          this.props.sendAnalytics(
              null, 
              this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
              "CREDIT CARD DETAILS", 
              {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": "CREDIT CARD DETAILS", "widgetSessionId": this.state.checkinSessionToken}, 
              0, 
              false,
              () => localStorage.setItem("checkin_ccdetails_event_sent", true)
          );
        }
      }
    }

    if(this.props.abortCheckinProcess==true && !this.state.selectedComp &&  !this.state.showIdCardCapture && !this.state.showGDPR && !this.state.showSelfieCapture && !this.state.showVerifyConfidance ){
      this.props.setSelectedIdType(null);
      this.props.setIdCardImageBack(null)
      this.props.setIdCardImage(null)
      this.props.setSelfieVideo(null)
      this.props.setGoHome(true)
      localStorage.removeItem("GDPR-Response")


      this.props.setAbortCheckinProcess(false);
    }

  }

  cancelCheckinProcess=()=>{
    this.props.setShowCustomPopup(true,{
      htmlTagId:"cancel-checkin-process",
      title:(this.props.allowUserLoginViaFindingReservation && this.isBookingInformationPage() ) ? this.props.t("check_in.cancel_checkin_process.findingReservation.title") : this.props.t("check_in.cancel_checkin_process.title"),
      subtitle:"",
      heading:(this.props.allowUserLoginViaFindingReservation && this.isBookingInformationPage() ) ? this.props.t("check_in.cancel_checkin_process.findingReservation.heading"): this.props.t("check_in.cancel_checkin_process.heading"),
      subHeading:"",
      primaryButtonText:(this.props.allowUserLoginViaFindingReservation && this.isBookingInformationPage() ) ? this.props.t("check_in.cancel_checkin_process.findingReservation.primaryButtonText"):  this.props.t("check_in.cancel_checkin_process.primaryButtonText"),
      secondaryButtonText:(this.props.allowUserLoginViaFindingReservation && this.isBookingInformationPage() ) ? this.props.t("check_in.cancel_checkin_process.findingReservation.secondaryButtonText"): this.props.t("check_in.cancel_checkin_process.secondaryButtonText"),
      secondaryButtonStyleIsUnderline:true,
      primaryOnClick:()=>{this.props.setShowCustomPopup(false,{})},
      closeOnClick:()=>{this.props.setShowCustomPopup(false,{})},
      secondaryOnClick:()=>{this.props.setAbortCheckinProcess(true);this.props.setShowCustomPopup(false,{})}
  })   
}

isBookingInformationPage=()=>{
  if(!this.state.selectedComp &&  !this.state.showIdCardCapture && !this.state.showGDPR && !this.state.showSelfieCapture && !this.state.showVerifyConfidance ){
    return true;
  }
  return false;
}


  componentDidMount(){
    setTimeout(()=>{
      scrollToTop();
    },100)
    
    let room = localStorage.getItem("room")
    if(room && room != "null"){
      this.setState({showErrorScreen:true, firstLaunch: false})
      return;
    }

    const today = new Date();
    const date = `${today.getFullYear()}-${this.monthFormatHandler(today.getMonth() + 1)}-${this.dayFormatHandler(today)}`
    this.setState({inputDateFormat: dateFormatHandler(today, this.props.dateFormat)})
    this.setState({todayDate: date});
    this.setState({selectedDate: date});
    window.scrollTo(0,0);


    if(this.props.currentWidgetObj.surveyId){
      this.setState({showGDPR: true})
    }
    // let lastName = this.getObject('Surname') ? this.getObject('Surname').toLowerCase() : ""
    // let booking_ref = ''
    // let roomNo = ''

    // if(matrix[lastName]){
    //   booking_ref = matrix[lastName].bookingNo
    //   roomNo = matrix[lastName].bookingNo.substring(4,7);
    //   const updtAdd = {...this.state.address,
    //     ["country"]: matrix[lastName].countryId};
    
    //   this.setState({address:updtAdd})
    // }

    // this.setState({
    //   bookingNumber: booking_ref,
    //   roomNo: roomNo
    // })

    // this.setState({lastName: this.getObject('Surname')});
    
    if(this.props.selfieVideo){
      this.readFile(this.props.selfieVideo.videoUrl,"image",this.guestBookFormData);
    }
    
    if(this.props.idCardImage){
      this.readFile(this.props.idCardImage.imageUrl,"image",this.guestBookFormData);
    }

    this.props.getCardChecksData(this.state.sessionToken,() => {this.setState({showLoader: false, loderMessage: ''});(this.maxRetry = (this.props.cardChecksData.guestValidationMaxRetry ? this.props.cardChecksData.guestValidationMaxRetry : 3))} );


    GetDynamicBookingForm((data) => this.setState({DynamicBookingFormRequestData: data}));
    
    mobileCheckinColorConfig(this.props.menuColor);
    this.props.getAllergyOptions(this.state.sessionToken);
    this.props.getCountryOptions(this.state.sessionToken)
    this.props.getGuestDocListData(this.state.sessionToken)

    let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
    const checkin_bnumber_event_sent = localStorage.getItem("checkin_bnumber_event_sent");
    const checkin_clicked_event_sent = localStorage.getItem("checkin_clicked_event_sent");

    if(!checkin_clicked_event_sent){
      console.log("checkin_clicked_event_sent", !checkin_clicked_event_sent)
      this.props.setCheckinWidgetLaunchTime(new Date);
      this.props.sendAnalytics(
          null, // as no guesdetails in logout state 
          this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
          CLICKED, 
          {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": "BOOKING NUMBER", "widgetSessionId": this.state.checkinSessionToken, "widgetTypeName": this.props.currentWidgetObj.widgetTypeName }, 
          0, 
          false, // guest is not logged in,
          () => localStorage.setItem("checkin_clicked_event_sent", true)
      );
    }
    if(!checkin_bnumber_event_sent && !this.props.currentWidgetObj.surveyId){
      let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
      this.props.sendAnalytics(
          null, // as no guesdetails in logout state 
          this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
          "BOOKING NUMBER", 
          {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": "BOOKING NUMBER", "widgetSessionId": this.state.checkinSessionToken}, 
          0, 
          false, // guest is not logged in
          () => localStorage.setItem("checkin_bnumber_event_sent", true)
      );
    }
    this.props.setCheckinCurrentPageName("BOOKING NUMBER")

    if(this.props.disableCheckInWalkthrough){
      this.setState({firstLaunch: false});
    }

    if(localStorage.getItem("checkInGuestPreInfo")){

      const checkInGuestPreInfo = JSON.parse(localStorage.getItem("checkInGuestPreInfo"));

      
      if(checkInGuestPreInfo){

        if(sessionStorage.getItem("clearWebVerification")) this.setState({firstLaunch: false});
        this.setState({ lastName:checkInGuestPreInfo.lastName, bookingNumber: checkInGuestPreInfo.bookingNumber || "", roomNo: checkInGuestPreInfo.bookingNumber ? checkInGuestPreInfo.bookingNumber.substring(4,7) : ""})
        if(checkInGuestPreInfo.checkinDate) this.setState({selectedDate: checkInGuestPreInfo.checkinDate, inputDateFormat: dateFormatHandler(checkInGuestPreInfo.checkinDate, this.props.dateFormat)});
        
        setTimeout(() => {
          if( sessionStorage.getItem("clearWebVerification") && (checkInGuestPreInfo.lastName || checkInGuestPreInfo.bookingNumber)) this.guestBookingHandler();
        }, 200);

        // localStorage.removeItem("checkInGuestPreInfo")
      }
    }
    
  }

  sendBookingNumberEvent = () => {

    let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})

    const checkin_bnumber_event_sent = localStorage.getItem("checkin_bnumber_event_sent");
    if(!checkin_bnumber_event_sent){
      this.props.sendAnalytics(
          null, // as no guesdetails in logout state 
          this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
          "BOOKING NUMBER", 
          {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": "BOOKING NUMBER", "widgetSessionId": this.state.checkinSessionToken}, 
          0, 
          false, // guest is not logged in
          () => localStorage.setItem("checkin_bnumber_event_sent", true)
      );
    }
  }


  abortCheckin =()=>{
    this.props.setAbortCheckinProcess(true) 
  }




  render() {
        const {t} = this.props
        return (
       <>
       { !this.state.showIdCardCapture && !this.state.showGDPR && !this.state.showSelfieCapture && !this.state.showVerifyConfidance && 
        <div className="main-container">
          {!this.state.selectedComp ? <Fragment>
            <header className="inner-pages w-footer subpages">
              <a onClick = {() => {
                                    this.props.setSelectedIdType(null);
                                    this.props.setIdCardImageBack(null)
                                    this.props.setIdCardImage(null)
                                    this.props.setSelfieVideo(null)
                                    this.props.setGoHome(true)
                                    localStorage.removeItem("GDPR-Response")
            }}  className="button-back"></a>
              <div className="heading align-center">
                <div class="splash-brand">
                    <img src={`${CMSPath}${this.props.logo}`} />
                </div>

               </div>

               {  process.env.REACT_APP_NEWER_DESIGN=="true" && 

                       <div class="cancel-check-in" onClick={this.cancelCheckinProcess}>
                        <div>Cancel </div>
                                <span style={{}}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M15 5L5 15M5 5L15 15" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                </span>
                        </div>
               }

            </header>
            <section className="widgets padding-0 margin-0 container-bg">

              <div class="widget-header widget-header-checkin booking-information">
                  { this.props.currentWidgetObj.widgetHeaderImageUrl && 
                      <div class="widget-header-img">
                          <img src={`${CMSPath}${this.props.currentWidgetObj.widgetHeaderImageUrl}`} alt={this.props.currentWidgetObj.displayName} />
                      </div>
                  }
                  <div class="widget-header-title">{this.props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</div>
              </div>


              <div className="widgets">
                <div className="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1">
                  <h2 className = "all-caps" dangerouslySetInnerHTML={{__html:t('check_in.booking_details')}}></h2>
                </div>
                <div className="form-window">
                  
                  <div className="form-window-heading">
                  { process.env.REACT_APP_NEWER_DESIGN=="true" ?
                  (this.props.currentWidgetObj.widgetType == "Pre Check-in" ? 
                   t('pre_checkIn.enter_booking_information'):
                  t('check_in.enter_booking_information'))
                  :
                  t('check_in.enter_booking_information')
                  }

                  {/* {t('check_in.enter_booking_information')} */}
                  </div>
                  <div className="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                    <div className="form-row margin-bottom-1">
                      <label for="lastName">{t('check_in.last_name')}<span style = {{color:"red"}}>*</span></label>
                      <input name="lastName" autoComplete='family-name' id="guestSurname" type="text" value={this.state.lastName} onChange = {(e) => this.setState({lastName:e.target.value})}/>
                    </div>
  
                    {this.state.showBookingField && <div className="form-row margin-bottom-1">
                      <label for="bookingNum">{this.props.cardChecksData && this.props.cardChecksData.bookingNumberLabel ? this.props.cardChecksData.bookingNumberLabel : t('check_in.booking_no')}<span style = {{color:"red"}}>*</span></label>
                      <input name="bookingNum" id="bookingNum" type="text" value = {this.state.bookingNumber} onChange = {this.handleBookingRefNo}/>
                    </div>}

                    <div className="form-row margin-bottom-1">
                      <label>{t('check_in.checkin_date')}</label>
                      { this.props.currentWidgetObj.widgetType == "Pre Check-in" ?
                      // <input name="scanId" onChange = {(e) => this.setState({selectedDate:e.target.value})} id="scanId" type="date" value = {this.state.selectedDate}/>
                      <input name="scanId" type="button" value={(this.props.dateFormat && this.props.dateFormat != null) ? this.state.inputDateFormat : this.state.selectedDate} onClick={() => this.setState({renderDateInput: !this.state.renderDateInput})} />
                      : <input name="scanId" onChange = {(e) => this.setState({todayDate:e.target.value, inputDateFormat: e.target.value})} id="scanId" disabled={true} type={(this.props.dateFormat && this.props.dateFormat != null) ? "text" : "Date"} value = {(this.props.dateFormat && this.props.dateFormat != null) ? this.state.inputDateFormat : this.state.todayDate}/>}
                    </div>
                    <p ><span style = {{color: "red"}}>*</span> {t('check_in.required')}</p>
                    <p className='checkin-required' style={{color: '#C60000', fontSize: '0.9rem', fontStyle:'italic'}}>{this.props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.pre_checkIn_only_message') : t(`check_in.checkIn_only`)}</p>
                    {this.props.cardChecksData.idValidationInterface == "Clear" && <p style={{color: '#C60000', fontSize: '0.9rem', fontStyle:'italic'}}>{t(`check_in.clear_notOpt_message`)}</p>}
                    {/* {(this.state.guest_book_error && !this.state.guest_book_loading) && <p style = {{color:"red"}}>{this.state.guest_book_error_msg}</p>} */}
      
                    <div className="form-controls">
                        {this.props.cardChecksData.idValidationInterface == "Clear" ?
                          <button id='clear-next-button' class="primary w-100" onClick={() => { this.guestBookingHandler(); }} disabled={!this.state.lastName} > <span class="icon"> <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49.05 48.26"><g id="Layer_1-2" data-name="Layer 1"><g><circle cx="24.47" cy="6.42" r="2.53" /><circle cx="24.47" cy="41.95" r="2.53" /><circle cx="20.47" cy="12.16" r="2.53" /><circle cx="14.84" cy="16.74" r="2.53" /><circle cx="7.58" cy="18.05" r="2.53" /><circle cx="6.47" cy="10.95" r="2.53" /><circle cx="14.26" cy="9.63" r="2.53" /><circle cx="14.26" cy="38.53" r="2.53" /><circle cx="17.37" cy="45.74" r="2.53" /><circle cx="17.37" cy="2.53" r="2.53" /><circle cx="6.47" cy="37.26" r="2.53" /><circle cx="7.58" cy="29.63" r="2.53" /><circle cx="12.32" cy="23.84" r="2.53" /><circle cx="2.53" cy="23.84" r="2.53" /><circle cx="14.84" cy="30.95" r="2.53" /><circle cx="20.47" cy="35.74" r="2.53" /><circle cx="28.58" cy="36.11" r="2.53" /><circle cx="34.21" cy="31.53" r="2.53" /><circle cx="41.47" cy="30.21" r="2.53" /><circle cx="42.58" cy="37.32" r="2.53" /><circle cx="34.79" cy="38.63" r="2.53" /><circle cx="34.79" cy="9.74" r="2.53" /><circle cx="31.68" cy="2.53" r="2.53" /><circle cx="31.68" cy="45.74" r="2.53" /><circle cx="42.58" cy="11" r="2.53" /><circle cx="41.47" cy="18.63" r="2.53" /><circle cx="36.74" cy="24.42" r="2.53" /><circle cx="46.53" cy="24.42" r="2.53" /><circle cx="34.21" cy="17.32" r="2.53" /><circle cx="28.58" cy="12.53" r="2.53" /></g></g></svg></span>
                            Verify with CLEAR
                          </button>
                      : <button className="primary w-100" onClick = {() => {this.guestBookingHandler();}} disabled = {!this.state.lastName}>{this.state.guest_book_error ? t('check_in.try_again') : t('check_in.continue')}</button>}
                    </div>
                  </div>
                </div> 
              </div>
            </section>

            {this.state.goBack ? <HashRouter>
              <Redirect exact to='/checkin/id' /> 
            </HashRouter> : null}
          </Fragment>
          : this.state.selectedComp == "screen2" ? this.props.cardChecksData.cardValidationInterface == "Stripe" ?
            <StripeCardFlow
              setupIntentClientSecret={this.state.setupIntentSecret}
              publishableKey={this.props.cardChecksData.publishableKey} 
              showCardVerified={(userInfo) => { this.setState({firstName: userInfo.firstName, lastName: userInfo.lastName}); this.setState({showCardVerified: true})}}
              backBtn = {() => this.setState({selectedComp : null})} 
              showLoader={bool => this.setState({showLoader: bool})}
              confirmationNumber={this.state.bookingNumber}
              // firstName={this.getObject('Name')}
              // lastName={this.getObject('Surname')}
              firstName={this.state.firstName}
              lastName={this.state.lastName}
              showFailScreen={(status, message, exitCheckinFlow = false) => { console.log("show Fail screen called")
                this.setState({showFailScreen: status, apiFailErrorMsg: message, exitCheckinFlow: exitCheckinFlow})}} 
              setcardVerified={(status, token) => this.setState({cardVerified: status, cardToken: token})}
              iscardVerified={this.state.cardVerified}
              next = {(userInfo) => { this.setState({firstName: userInfo.firstName, lastName: userInfo.lastName}); this.setState({selectedComp : "screen3"});scrollToTop()}}
              countryOptions={this.props.countryOptions}
              guestBookFormData={this.guestBookFormData}
              goBack = {() => this.setState({goToFirstStep: true})}
              canSkipCardValidation={true}
              /> :
              this.props.cardChecksData.cardValidationInterface == "Shift4_V1" ?
              <Shift4 
              publicKey={this.props.cardChecksData.publishableKey} 
              secretKey={this.props.cardChecksData.apiSecretKey}
              confirmationNumber={this.state.bookingNumber}
              firstName={this.state.firstName}
              lastName={this.state.lastName}
              email={this.state.email}
              iscardVerified={this.state.cardVerified}
              showCardVerified={(userInfo) => { this.setState({firstName: userInfo.firstName, lastName: userInfo.lastName}); this.setState({showCardVerified: true})}}
              showFailScreen={(status, message , callback) => {
                if(callback){
                  this.setState({exitCheckinFlow: true})
                }
                this.setState({showFailScreen: status, apiFailErrorMsg: message})}}
              backBtn = {() => this.setState({selectedComp : null})}
              next = {(userInfo) => { this.setState({firstName: userInfo.firstName, lastName: userInfo.lastName}); this.setState({selectedComp : "screen3"});scrollToTop()}} />
              :
               this.props.cardChecksData.cardValidationInterface == "Shift4" ?             
              <Shift4_V2
              lastName={this.state.lastName}
              confirmationNumber={this.state.bookingNumber}
              backBtn={() => {this.setState({ selectedComp: null })}}
              showCardVerified={( userInfo) => { this.setState({ showCardVerified: true, firstName:userInfo.firstName, lastName:userInfo.lastName  }) }}
              setcardVerified={(status) => this.setState({ cardVerified: status })} // check for token
              iscardVerified={this.state.cardVerified}
              next={() => {this.setState({ selectedComp: "screen3" }); scrollToTop() }}
              showFailScreen={(status, message, callback) => {
                if (callback) {
                   this.setState({ selectedComp: null })
                   this.props.setSelectedIdType(null);
                   this.props.setIdCardImageBack(null)
                   this.props.setIdCardImage(null)
                   this.props.setSelfieVideo(null)
                    }
                  this.setState({ showFailScreen: status, apiFailErrorMsg: message })
                 }}
              cancelCheckinProcess={this.cancelCheckinProcess}
              showLoader={bool => this.setState({ showLoader: bool })}
              />:
                  this.props.cardChecksData.cardValidationInterface == "FPay" ? 

                  <FreedomPay
                    firstName={this.state.firstName}
                    lastName={this.state.lastName}
                    phone={this.state.phone}
                    email={this.state.email}
                    confirmationNumber={this.state.bookingNumber}
                    countryOptions={this.props.countryOptions}
                    backBtn={() => { this.setState({ selectedComp: null }) }}
                    showCardVerified={(userInfo) => { this.setState({ firstName: userInfo.firstName, address: userInfo.address, phone: userInfo.phone, email: userInfo.email }); this.setState({ showCardVerified: true })
                  }}
                    setcardVerified={(status) => this.setState({ cardVerified: status })} // check for token
                    iscardVerified={this.state.cardVerified}
                    next={(userInfo) => { this.setState({ firstName: userInfo.firstName }); this.setState({ selectedComp: "screen3" }); scrollToTop() }}
                    showFailScreen={(status, message, callback) => {
                      if(callback){
                        this.setState({selectedComp: null})
                        this.props.setSelectedIdType(null);
                        this.props.setIdCardImageBack(null)
                        this.props.setIdCardImage(null)
                        this.props.setSelfieVideo(null)
                      }
                      this.setState({ showFailScreen: status, apiFailErrorMsg: message })
                    }}
                    showLoader={bool => this.setState({ showLoader: bool })}
                  /> 
              :
              <Lightbox  
              showCardVerified={(userInfo) => { this.setState({firstName: userInfo.firstName, lastName: userInfo.lastName}); this.setState({showCardVerified: true})}}
              confirmationNumber={this.state.bookingNumber}
              // firstName={this.getObject('Name')}
              // lastName={this.getObject('Surname')}
              firstName={this.state.firstName}
              lastName={this.state.lastName}
              backBtn = {() => this.setState({selectedComp : null})}
              showFailScreen={(status, message , callback) => {
                if(callback){
                  this.setState({exitCheckinFlow: true})
                }
                this.setState({showFailScreen: status, apiFailErrorMsg: message})}}
              setcardVerified={(status, token) => this.setState({cardVerified: status, cardToken: token})}
              iscardVerified={this.state.cardVerified}
              showLoader={bool => this.setState({showLoader: bool})}
              next = {(userInfo) => { this.setState({firstName: userInfo.firstName, lastName: userInfo.lastName}); this.setState({selectedComp : "screen3"});scrollToTop()}}/>
          : this.state.selectedComp == "screen3" &&
          <BookingForm
            checkinGuestLoading={this.state.checkinGuest_loading}
            email={this.state.email}
            phone={this.state.phone}
            birthDate={this.state.birthDate}
            eta={this.state.eta}
            address={this.props.checkInAddress}
            firstName={this.state.firstName}
            lastName={this.state.lastName}
            extraData={this.state.extraData}
            dynamicFormIndex={this.state.dynamicFormIndex}
            DynamicBookingFormRequestData={this.state.DynamicBookingFormRequestData}
            primaryButtonText={this.state.showAccompanyGuestFlow ? t('check_in.next') : this.props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.precheckin') : t('check_in.checkin')}
            goBack={() => this.setState({ selectedComp: (this.props.cardChecksData.guestImagesCheckEnabled && this.props.accompanyGuests.length > 0) ? "screen2" : null })}
            next={this.checkInInfoHandler}
            cancelCheckinProcess={this.cancelCheckinProcess}
          />}

          { this.state.roomLinkSuccess == true &&
            <HashRouter>
              <section id="app-body" className="col">
              <Redirect exact to='/checkin/confidence/verified/booking/book_success/' />
              </section>
            </HashRouter>
          }

          { this.state.showCardVerified && 
            <SuccessFailScreen
              status={this.props.cardStatus} 
              statusTitle={this.props.statusTitle} 
              statusMessage1={this.props.statusMessage1} 
              statusMessage2={this.props.statusMessage2} 
              showClose={true}
              close={() => this.setState({showCardVerified: false})}
              continue={() => {
                console.log('next is getting called')
                  this.setState({selectedComp : "screen3"})
                  this.setState({showCardVerified: false})
                }}
            />}
          {
          this.state.showLoader && 
          <Loader displayMsg="Verifying data..." />
        }
        {this.state.showErrorScreen && <LoggedInErrorScreen backBtn = {() => {this.props.setGoHome(true)}} 
          errorMsg = {t('check_in.error_msg')} headerText = {t('check_in.error_header_text')}/>}

          {this.state.showFailScreen && <APIFailScreen backBtn = {() => { this.state.exitCheckinFlow ? this.props.setGoHome(true) : this.state.goToFirstStep ? this.setState({selectedComp: null, showFailScreen:false, errorScreenShown: true }) : this.setState({showFailScreen:false, errorScreenShown: true})}} errorMsg = {this.state.apiFailErrorMsg}/>}
        </div>}

        {this.state.showIdCardCapture ?
          (
            this.props.cardChecksData.idValidationInterface == "Clear" ?
            <ClearVerification confirmationNumber={this.state.bookingNumber} checkinDate={this.state.selectedDate} skip={() => {this.setNextScreen("VerifyIdAndSelfie"); this.setState({showIdCardCapture: false})}} lastName={this.state.lastName} goBack={() => this.setState({showIdCardCapture: false})} handleCLEARData={this.handleCLEARData} setNextScreen={() => {this.setNextScreen("VerifyIdAndSelfie"); this.setState({showIdCardCapture: false})}} />
            :
            (
              process.env.REACT_APP_SHOW_SELFIE_AND_ID_SCAN_TOGETHER=="true" ?
              <ScanIdandSelfieTogether
                goBack={() => this.setState({showIdCardCapture: false})} 
                skip={() => {this.setNextScreen("VerifyIdAndSelfie"); this.setState({showIdCardCapture: false})}} 
                setConfidanceScreen={() => this.setState({showVerifyConfidance: true, showIdCardCapture: false})}
                cancelCheckinProcess={this.cancelCheckinProcess}
                />:
                <IdCardCapture 
                goBack={() => this.setState({showIdCardCapture: false})} 
                skip={() => {this.setNextScreen("VerifyIdAndSelfie"); this.setState({showIdCardCapture: false})}} 
                setSelfieScreen={() => this.setState({showIdCardCapture: false, showSelfieCapture: true})} 
                />
            )

          ):null}

        {
          (this.state.firstLaunch && (this.props.allowUserLoginViaFindingReservation ? (Boolean(this.state.showIdCardCapture)) : true)) && <CheckinStepsGuide guestImagesCheckEnabled={this.props.cardChecksData.guestImagesCheckEnabled} accompanyGuestEnabled={this.props.cardChecksData.accompanyGuestApproach} cardCheckEnabled={this.props.cardChecksData.cardValidationEnabled} idVerificationDisabled={this.props.cardChecksData.idValidationInterface == "disabled" ? true : false} clearFlowEnabled={this.props.cardChecksData.idValidationInterface == "Clear" ? true : false} setStepsGuide={() => this.setState({firstLaunch: false})} backActionIfAllowUserLoginViaFindingReservationEnabled={()=>{this.setState({showIdCardCapture: false})}}/>
        }
        {
          this.state.showGDPR && <GdprPolicy setAPIFailScreen={(status) => this.setState({showFailScreen: status, exitCheckinFlow: true, apiFailErrorMsg: "Failed to get GDPR policy"})} setLoader={(status, msg) => this.setState({showLoader: status, displayMsg: msg})} currentWidget={this.props.currentWidgetObj} goNext={() => {this.setState({showGDPR: false});this.sendBookingNumberEvent();}} goBack={() => {this.props.setGoHome(true);localStorage.removeItem("GDPR-Response")}}  />
        }
        {
          this.state.showVerifyConfidance && <VerifyConfidance goBack={() => this.setState({showVerifyConfidance: false, showIdCardCapture: true})} goBacktoSelfie={() => this.setState({showVerifyConfidance: false, showSelfieCapture: true})} setNextScreen={() => this.checkIDLastName()} />
        }
        { this.state.renderDateInput &&
          <div className="overlay" onClick={() => this.setState({renderDateInput: false})}>
          <div onClick={(event) => {event.stopPropagation()}} class="overlay-date">
              <style>{this.dateInputCss}</style>
              <DayPicker
                  mode="single"
                  selected={new Date(this.state.selectedDate)}
                  onSelect={(selectedDate) => this.handlePreCheckInSelectedDate(selectedDate)}
                  disabled={{
                      before: new Date(this.state.todayDate),
                      after: this.props.preCheckInTimeLimit && this.props.preCheckInTimeLimit >= 0 ? new Date(new Date(this.props.serverTimeDate.split("T")[0]).getTime() + (Math.floor(this.props.preCheckInTimeLimit / 24)) * 24 * 60 * 60 * 1000) : undefined
                  }}
              />
          </div>
        </div>
        }
        </>
    )
  }
}


const mapStateToProps = state => {
  return{
    idCardResponse: state.store2.idCardResponse,
    idCardBackResponse: state.store2.idCardBackResponse,
    selfieResponse: state.store2.selfieResponse,
    bookingRef: state.store2.booking_ref,
    idCardImage: state.store2.idCardImage,
    selfieVideo: state.store2.selfieVideo,
    cardChecksData: state.store2.cardChecksData,
    menuColor: state.store.home.MenuColor,
    logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
    cardStatus: state.store2.checkinCard.cardStatus,
    statusTitle: state.store2.checkinCard.statusTitle,
    statusMessage1: state.store2.checkinCard.statusMessage1,
    statusMessage2: state.store2.checkinCard.statusMessage2,
    allergyOptions: state.store2.guestBooking.allergyOptions || ['None', 'Gluten intolerant', 'Lactose intolerant', 'Nuts allergy', 'Seafood', 'Other'],
    countryOptions: state.store2.guestBooking.countryOptions || ['Australia', 'Austria', 'Belgium', 'Brazil', 'China', 'Costa Rica', 'India', 'Japan', 'Russia', 'Sweden', 'USA', 'UK' ],
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    guestDetail: state.store.home.guestDetails,
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    serverTimeDate: state.store.home.serverTimeDate.date,
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    currentHomePage: state.store2.currentHomePage,
    accompanyGuests: state.store2.accompanyGuests,
    disableCheckInWalkthrough: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.disableCheckInWalkthrough ? toBool(state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.disableCheckInWalkthrough) : false,
    checkInStartTime: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.checkInStartTime,
    preCheckInTimeLimit: state.store.home.clientConfig.webAppWidgetsInfo ? state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.preCheckInTimeLimit : undefined,
    preCheckInEnabled: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.preCheckInEnabled ? toBool(state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.preCheckInEnabled) : false,
    mobileCheckInDisabled: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.mobileCheckInDisabled ? toBool(state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.mobileCheckInDisabled) : false,
    dateFormat: state.store.home.clientConfig.extraConfigParam 
        ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT : "",
    checkInAddress : state.store2.checkInAddress,
    abortCheckinProcess: state.store2.abortCheckinProcess,
    allowUserLoginViaFindingReservation: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.allowUserLoginViaFindingReservation


  }
}

export default connect(mapStateToProps,{ 
  setBookingRef, 
  setCheckinRoomNo, 
  validateGuestdetail,
  popupOpenClose,
  getGuestDocListData,
  getAllergyOptions,
  getCountryOptions,
  getCardChecksData,
  setGoHome,
  setCheckInAddress,
  setCheckinWidgetLaunchTime,
  setAbortCheckinProcess,setShowCustomPopup,
  cardValidation, setSelfieVideo, setIdCardImage, setIdCardImageBack, sendAnalytics, setCheckinCurrentPageName, setSelectedIdType
 })(withTranslation('translations')(Booking));